import { BUCKET_INTERVAL } from "@/utils/date/timeBucketing"

import { getBrowserTimezone } from "./timezoneUtils"

/**
 * Smart date formatting for chart labels based on bucket interval
 * Uses browser's local timezone for display
 */
export const formatChartDateLabel = (
  date: Date,
  bucketInterval: string,
  timezone?: string,
): string => {
  const tz = timezone || getBrowserTimezone()
  const isSubDaily = (
    [
      BUCKET_INTERVAL.FIFTEEN_MINUTES,
      BUCKET_INTERVAL.ONE_HOUR,
      BUCKET_INTERVAL.FOUR_HOURS,
    ] as string[]
  ).includes(bucketInterval)

  if (isSubDaily) {
    // For sub-daily intervals: show time (e.g., "2:00 PM" or "Dec 25 2:00 PM")
    const timeOnly = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: date.getMinutes() === 0 ? undefined : "2-digit",
      hour12: true,
      timeZone: tz,
    })

    // For current day, show time only; for other days, show "Dec 25 2:00 PM"
    const isToday =
      date.toLocaleDateString("en-US", { timeZone: tz }) ===
      new Date().toLocaleDateString("en-US", { timeZone: tz })
    return isToday
      ? timeOnly
      : `${date.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: tz })} ${timeOnly}`
  }
  // For daily+ intervals: show date only (e.g., "Dec 25")
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    timeZone: tz,
  })
}
